import {html} from '@isceco/widget-library2/external/lit';
import '@isceco/widget-library2/basic-elements/Link/Link'

export default class EmailCell {

  render(i18n, cell) {
    if (isEmpty(cell)) {
      return html`<isceco-link></isceco-link>`
    } else {
      return html`
        <isceco-link
          icon="envelope"
          text="${cell}"
          url="mailto:${cell}"
        ></isceco-link>
      `
    }
  }
}
